<section class="custom-section">
  <customer-title-content
    [title]="labels.userManagement"
    [content]="labels.userManagementDescription">
  </customer-title-content>
  <section
    *ngIf="isVerifiedMode"
    class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-grey-100">
    <mat-icon class="text-grey-400">
      info
    </mat-icon>
    <customer-title-content
      class="fx-g-1"
      [content]="labels.atLeastOneOwner">
    </customer-title-content>
  </section>
  <ng-container *ngIf="latestUser as user">
    <ng-container *ngIf="!user.controls.added.value">
      <div class="fx-row mb-6 fx-gap-3">
        <customer-simple-input
          class="w-full"
          [placeholder]="labels.userManagementPlaceholder"
          [input]="user.controls.email"
          [errorMessage]="user.controls.email.errors | userEmailValidatorPipe : labels">
        </customer-simple-input>
        <customer-simple-button
          [label]="labels.add"
          [disabled]="user.controls.email.invalid || user.controls.email.pending"
          [action]="isVerifiedMode ? onUserChangeWrapper() : updateUserInConnext(user)">
        </customer-simple-button>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="{ disabledEmail: disabledOwnerEmail$ | async } as ownerGuard">
  <section class="tw-w-full overflow-hidden border-1 radius-4 tw-border-grey-100">
    <div class="text-grey-400 text-center tw-font-medium tw-text-sm fx-row fx-gap-3 fx-align-center py-2 px-3 h-16 border-b-1 border-grey-200">
      <div class="ellipsed min-w-10"></div>
      <div class="ellipsed text-left fx-g-1 fx-b-0">{{ labels.email }}</div>
      <div class="ellipsed text-left tw-w-[30%]">{{ labels.authorizations }}</div>
    </div>
    <!-- Users Row -->
    <ng-container *ngFor="let user of connextUsers.controls.users.controls; let i = index; let odd = odd">
      <div
        *ngIf="user.value.added && user.value.userLevel !== UserPermissions.hidden"
        class="text-grey-400 text-center tw-font-normal tw-text-base fx-row fx-gap-3 fx-align-center pr-1 px-3 h-16 border-b-1 border-greylight-100 hover"
        [class.bg-grey-100]="odd">
        <div
          class="fx-center"
          [matTooltip]="labels.atLeastOneOwner"
          [matTooltipDisabled]="user.value.email !== ownerGuard.disabledEmail">
          <mat-checkbox
            color="accent"
            [attr.data-testid]="'user-' + user.value.email + '-delete-select'"
            [class.hidden]="!isVerifiedMode && myEmail === user.value.email?.toLowerCase()"
            [disabled]="(!isVerifiedMode && myEmail === user.value.email?.toLowerCase()) || user.value.email === ownerGuard.disabledEmail"
            [checked]="user.value.isSelected"
            (change)="user.controls.isSelected.setValue($event.checked)">
          </mat-checkbox>
        </div>
        <div class="text-left tw-tabular-nums tw-font-normal tw-text-base ellipsed fx-g-1 fx-b-0">
          <ngx-copy-to-clipboard
            *ngIf="user.value.email as email"
            class="w-full"
            position="right"
            copiedTooltip="Copied"
            tooltip="Click to copy"
            [textToCopy]="email">
            <span class="ellipsed">
              {{ email }}
            </span>
          </ngx-copy-to-clipboard>
        </div>
        <div class="tw-tabular-nums tw-font-normal tw-text-base tw-w-[30%]">
          <!-- User Level -->
          <mat-form-field
            subscriptSizing="dynamic"
            class="custom-mat-form-field w-full custom-border-bottom">
            <mat-select
              [disabled]="!isVerifiedMode && myEmail === user.value.email?.toLowerCase()"
              [value]="user.value.userLevel"
              [attr.data-testid]="'user-' + user.value.email + '-permission'"
              (selectionChange)="updatePermissions(user, $event.value)">
              <mat-option
                *ngFor="let permission of userPermissions"
                class="tw-tabular-nums tw-font-normal tw-text-base"
                [attr.data-testid]="'user-' + user.value.email + '-permission-' + permission"
                [value]="permission">
                {{ permission | userPermission }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </section>
  </ng-container>

  <div class="fx-row fx-align-center fx-justify-end fx-gap-1">
    <customer-simple-button
      type="warning"
      [label]="labels.deleteSelected"
      [attr.data-testid]="'delete-selected-users'"
      [disabled]="!isAnyUserSelected"
      [action]="useDirectDelete ? emitDeleteUsers : (isVerifiedMode ? removeUsers : removeSelectedUsers)">
    </customer-simple-button>

    <ng-content select="[menu-options]"></ng-content>
  </div>
  <div
    *ngIf="showUnsavedChanges && connextUsers.controls.isModified.value"
    class="fx-row fx-justify-evenly fx-wrap fx-gap-3 text-grey-400 text-300 body-2">
    <section class="border-1 fx-center fx-gap-3 p-1 radius-4 radius-2 border-grey-100 w-full">
      <mat-icon class="text-orange-400">
        info
      </mat-icon>
      <customer-title-content
        class="fx-g-1"
        [content]="labels.thereAreUnsavedChanges">
      </customer-title-content>
    </section>
  </div>
</section>
